import { useQuery } from '@tanstack/react-query';
import { getDisableTaskOutline } from 'shared/services/local-storage';

export const queryKey = 'disable-task-outline';

export const useDisableTaskOutlineQuery = () =>
  useQuery({
    queryKey: [queryKey],
    queryFn: () => getDisableTaskOutline(),
  });
